import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faStar, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const [isPaused, setIsPaused] = useState(false);

  const testimonials = [
    {
      content: "Fex logistics is the best logistics i have used in Nigeria. Their service is topnotch and their delivery and updates with my customers are very timely. I choose FEX 12 times out of 10 every day of the week, twice on Sunday.",
      author: "Vendor",
      company: "Governor's",
      rating: 5
    },
    {
      content: "Hello There, we @Mayorfabrics _lagos online store have been using the services of Fex Logistics and we can say it has been a smooth sail all the way. Their services are satisfactory and we will recommend them over and over again.",
      author: "Vendor",
      company: "Mayorfabrics_lagos",
      rating: 5
    },
    {
      content: "Running my business and handling deliveries used to be so stressful. Working with independent riders was honestly a struggle — sometimes they missed pickups, delayed deliveries, and there was zero accountability for damaged packages. It was really affecting how smoothly things ran. But everything changed when I decided to sign up with Fex Logistics. The difference has been very clear, even customers can testify.",
      author: "Vendor",
      company: "Dainty decor",
      rating: 5
    },
    {
      content: "Their riders are reliable, professional, and always on time. I also love how easy it is to communicate with their team when a problem arises. They've made the logistics part of my business so much easier, and I can finally focus on growing instead of worrying about deliveries all the time.",
      author: "Vendor",
      company: "Gifftering.ng",
      rating: 5
    },
    {
      content: "For the past two years I have been using Fex Logistics services, I have had no issue of missing packages or anything of such. Their riders are polite, their services are swift, fast, and reliable.",
      author: "Vendor",
      company: "Regclassclothing",
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-black py-16 md:py-24">
      <div className="container mx-auto px-4 relative">

        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white">Testimonials</h1>
          <p className="text-gray-300 max-w-2xl mx-auto">Real feedback from vendors and businesses who trust Fex Logistics.</p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-gray-900 rounded-xl p-6 md:p-8 shadow-xl transition-all duration-500 hover:scale-105 hover:shadow-2xl border border-gray-800 hover:border-red-600 group relative overflow-hidden"
            >
              {/* Red accent at top */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-red-600"></div>

              {/* Quote icon with red accent */}
              <div className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full p-3 shadow-lg group-hover:scale-110 transition-all duration-300">
                <FontAwesomeIcon icon={faQuoteLeft} className="text-lg md:text-xl" />
              </div>

              {/* Stars with red accent */}
              <div className="flex mb-4 md:mb-6">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon
                    key={i}
                    icon={faStar}
                    className={`${i < t.rating ? 'text-red-500' : 'text-gray-600'} mr-1 transition-all duration-300 group-hover:scale-110`}
                    style={{ transitionDelay: `${i * 50}ms` }}
                  />
                ))}
              </div>

              {/* Testimonial content - Fixed text wrapping */}
              <p className="text-gray-300 italic mb-6 text-sm md:text-base leading-relaxed relative z-10 h-32 md:h-40 overflow-hidden group-hover:text-white transition-colors duration-300">
                "{t.content}"
              </p>

              {/* Author info with red accent */}
              <div className="flex items-center relative z-10">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-lg md:text-xl mr-4 shadow-lg group-hover:shadow-red-600/50 transition-all duration-300 group-hover:scale-110 flex-shrink-0">
                  {t.author.charAt(0)}
                </div>
                <div className="min-w-0 flex-1">
                  <h4 className="font-bold text-white text-base md:text-lg group-hover:text-red-400 transition-colors duration-300 truncate">{t.author}</h4>
                  <p className="text-gray-400 text-sm md:text-base group-hover:text-gray-300 transition-colors duration-300 truncate">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <Link
            to="/quote"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold py-3 md:py-4 px-8 md:px-10 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-red-600/50"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
